import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Navbar, Container, OverlayTrigger, Tooltip } from "react-bootstrap";

import iconGRC from "../../assets/images/icon-grc-disabled.svg";
import iconGRCactive from "../../assets/images/icon-grc2-active.svg";
import logoAdminactive from "../../assets/images/icon-admin.svg";
import logoAdmin from "../../assets/images/icon-admin-disabled.svg";
import logoHoverAdmin from "../../assets/images/icon-selected-admin.png";
import logoQMO from "../../assets/images/icon-qm.svg";
import logoQMOactive from "../../assets/images/icon-qm-active.svg";
import CallMadeIcon from "@mui/icons-material/CallMade";
import SouthEastIcon from "@mui/icons-material/SouthEast";
import StatistiqueHover from "../../assets/images/StatistiqueHover.png";
import Statistiqueactive from "../../assets/images/icon-stat.svg";
import Statistique from "../../assets/images/icon-stat-disabled.svg";
//import Statistique from "../../assets/images/Statitique.png";

import logoP1Selected from "../../assets/images/logoP1Selected.png";

import { useDispatch, useSelector } from "react-redux";
import { changeStyle } from "../../redux/actions/design";
import { statistic } from "../../redux/actions/statistic";
import VerticalBar from "../../assets/images/icon-vertical-bar.svg";
import { getPermissionsByuser } from "../../redux/actions/permissions";
import { libererAcces } from "../../redux/actions/calibrage";

const SmallNav = () => {
  const { isOpen, pageNumber } = useSelector((state) => state.design);
  const { statistics } = useSelector((state) => state.statistic);
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedDossier, setSelectedDossier] = useState(false);
  const [selectedGrc, setSelectedGrc] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(false);
  const [forHome, setForHome] = useState(false);

  const { dataPermissionsByuser } = useSelector((state) => state.permissions);
  let isAdmin = window.location.pathname.includes("/admin");
  let preValue = null;
  const currentPath = window.location.pathname;

  useEffect(() => {
    dispatch(statistic());
    if (currentPath === "/home") {
      setForHome(true);
    }
  }, []);
  useEffect(() => {
    dispatch(getPermissionsByuser());
  }, [dispatch]);

  function displaySection1() {
    dispatch(changeStyle(true, 1, "navbar"));
    if (currentPath === "/calibrage-en-cours") {
      let val = window.location.search;
      let pathChoice = val.substring(val.indexOf("=") + 1);
      dispatch(libererAcces(pathChoice));
    }
    history.push("/quality-monitoring");
  }

  function displaySection2() {
    if (currentPath === "/calibrage-en-cours") {
      let val = window.location.search;
      let pathChoice = val.substring(val.indexOf("=") + 1);
      dispatch(libererAcces(pathChoice));
    }
    history.push("/reporting");
    dispatch(changeStyle(true, 2, "navbar"));
  }

  function displaySection3() {
    history.push("/managment");
    dispatch(changeStyle(true, 3, "navbar"));
  }

  function displaySection4() {
    if (currentPath === "/calibrage-en-cours") {
      let val = window.location.search;
      let pathChoice = val.substring(val.indexOf("=") + 1);
      dispatch(libererAcces(pathChoice));
    }
    history.push("/admin");
    dispatch(changeStyle(true, 4, "navbar"));
  }
  const isPositive =
    parseFloat(statistics.averageGrade) - parseFloat(statistics.preGrade);

  return (
    <div
      className="navsubar-wrapper"
      style={{
        transform: window.devicePixelRatio === 1.25 ? "scale(0.91)" : "none",
      }}
    >
      <div className="container-sub-navbar p-0 ml-3">
        <Navbar className="screen-pc-stat screen-pc-stat1 p-0">
          <Container
            className={`container_stats ${
              forHome ? "blurred-text blurred-image" : ""
            }`}
          >
            <div className="stat-content">
              <div className="stat_number">
                {statistics.evaluations !== 0 ? statistics.evaluations : "-"}
              </div>
              <p className="text-statistic">Nombre total des évaluation</p>
            </div>
            <img alt="" src={VerticalBar} />
            <div className="stat-content">
              <div className="stat_number">
                {statistics.averageGrade !== null
                  ? statistics.averageGrade + "%"
                  : "-"}
              </div>
              <p className="text-statistic">Note Moyenne des évaluations</p>
            </div>
            <img alt="" src={VerticalBar} />
            <div className="stat-content">
              <div className="stat_number">
                {statistics.minNote !== null ? statistics.minNote : "-"}
              </div>
              <p className="text-statistic">Note Minimale des évaluations</p>
            </div>
            <img alt="" src={VerticalBar} />
            <div className="stat-content">
              <div className="stat_number">
                {statistics.maxNote !== null ? statistics.maxNote : "-"}
              </div>
              <p className="text-statistic">Note Maximale des évaluations</p>
            </div>
            <img alt="" src={VerticalBar} />
            <div className="stat-content">
              <div className="stat_number">
                {isPositive > 0 ? (
                  <CallMadeIcon style={{ color: "green" }} />
                ) : isPositive < 0 ? (
                  <SouthEastIcon style={{ color: "red" }} />
                ) : (
                  "-"
                )}
              </div>
              <p className="text-statistic">Tendance</p>
            </div>
          </Container>
        </Navbar>
      </div>
      <div className="nav-subar_icon-wrapp screen-pc-icons screen-pc-icons1 d-flex align-items-center">
        <div style={{ /*cursor: "pointer",*/ padding: "1px" }}>
          <OverlayTrigger
            key="bottom"
            placement="bottom"
            overlay={
              <Tooltip data-color="#FFA300" id={`tooltip-bottom`}>
                Round GRC
              </Tooltip>
            }
          >
            <img
              className="logo-resp"
              src={iconGRC}
              onMouseEnter={(e) => (e.currentTarget.src = iconGRCactive)}
              onMouseLeave={(e) => (e.currentTarget.src = iconGRC)}
            />
          </OverlayTrigger>
        </div>
        <div style={{ cursor: "pointer", padding: "1px" }}>
          {pageNumber === 1 ? (
            <img src={logoP1Selected} className="logo-resp" />
          ) : (
            <OverlayTrigger
              key="bottom"
              placement="bottom"
              overlay={
                <Tooltip data-color="#5800e2" id={`tooltip-bottom`}>
                  Quality Monitoring
                </Tooltip>
              }
            >
              <img
                src={logoQMO}
                className="logo-resp"
                onClick={displaySection1}
                onMouseEnter={(e) => (e.currentTarget.src = logoQMOactive)}
                onMouseLeave={(e) => (e.currentTarget.src = logoQMO)}
              />
            </OverlayTrigger>
          )}
        </div>
        {dataPermissionsByuser.filter((item) => item.DroitId === 2).length !==
        0 ? (
          <div
            style={{ cursor: "pointer", padding: "1px" }}
            onMouseEnter={() => setSelectedDossier(true)}
            onMouseLeave={() => setSelectedDossier(false)}
          >
            {pageNumber === 2 ? (
              <img src={StatistiqueHover} className="logo-resp" />
            ) : (
              <OverlayTrigger
                key="bottom"
                placement="bottom"
                overlay={
                  <Tooltip data-color="#F5714F" id={`tooltip-bottom`}>
                    Statistiques
                  </Tooltip>
                }
              >
                {selectedDossier ? (
                  <img
                    src={StatistiqueHover}
                    className="logo-resp"
                    width="90px"
                    height="90px"
                    onClick={displaySection2}
                  />
                ) : (
                  <img
                    src={Statistiqueactive}
                    className="logo-resp"
                    width="90px"
                    height="90px"
                    onClick={displaySection2}
                  />
                )}
              </OverlayTrigger>
            )}
          </div>
        ) : (
          <div style={{ /*cursor: "pointer",*/ padding: "1px" }}>
            <OverlayTrigger
              key="bottom"
              placement="bottom"
              overlay={
                <Tooltip data-color="#F5714F" id={`tooltip-bottom`}>
                  Statistiques
                </Tooltip>
              }
            >
              <img
                className="logo-resp"
                width="90px"
                height="90px"
                src={Statistique}
                onMouseEnter={(e) => (e.currentTarget.src = Statistiqueactive)}
                onMouseLeave={(e) => (e.currentTarget.src = Statistique)}
              />
            </OverlayTrigger>
          </div>
        )}
        {dataPermissionsByuser.filter((item) => item.DroitId === 1).length !==
        0 ? (
          <div
            style={{ cursor: "pointer", padding: "1px" }}
            onMouseEnter={() => setSelectedAdmin(true)}
            onMouseLeave={() => setSelectedAdmin(false)}
          >
            {isAdmin ? (
              <img
                src={logoHoverAdmin}
                className="logo-resp"
                width="90px"
                height="90px"
              />
            ) : (
              <OverlayTrigger
                key="bottom"
                placement="bottom"
                overlay={
                  <Tooltip
                    style={{ transform: "translate(1216px, 210px) !important" }}
                    data-color="#FD3D71"
                    id={`tooltip-bottom`}
                  >
                    Admin
                  </Tooltip>
                }
              >
                {selectedAdmin ? (
                  <img
                    src={logoHoverAdmin}
                    className="logo-resp"
                    width="90px"
                    height="90px"
                    onClick={displaySection4}
                  />
                ) : (
                  <img
                    src={logoAdminactive}
                    className="logo-resp"
                    width="90px"
                    height="90px"
                    onClick={displaySection4}
                  />
                )}
              </OverlayTrigger>
            )}
          </div>
        ) : (
          <div style={{ /*cursor: "pointer",*/ padding: "1px" }}>
            <OverlayTrigger
              key="bottom"
              placement="bottom"
              overlay={
                <Tooltip
                  style={{ transform: "translate(1216px, 210px) !important" }}
                  data-color="#FD3D71"
                  id={`tooltip-bottom`}
                >
                  Admin
                </Tooltip>
              }
            >
              <img
                className="logo-resp"
                src={logoAdmin}
                onMouseEnter={(e) => (e.currentTarget.src = logoAdminactive)}
                onMouseLeave={(e) => (e.currentTarget.src = logoAdmin)}
              />
            </OverlayTrigger>
          </div>
        )}
      </div>
    </div>
  );
};

export default SmallNav;
